<template>
    <div class="text-center">
        <div class="flex flex-wrap w-full justify-center items-center p-5">
            <div class="lg:mr-10">
                <img :src="track.layout" class="lg:mr-10">
                <h2 class="text-xl lg:text-3xl font-black uppercase">{{ track.name }}</h2>
            </div>
            <div class="flex justify-center items-center flex-col">
                <h5 class="mt-5 lg:mt-10 mb-2 lg:mb-4 text-5xl font-bold uppercase underline decoration-dotted decoration-red-600">Plan <span class="text-green-500">{{ this.plan }}</span></h5>
                <h4 class="text-2xl lg:text-4xl mb-2 lg:mb-4 font-bold uppercase">{{ track.laps }} lap race</h4>
                <h6 class="text-xl lg:text-3xl mb-4 lg:mb-8 uppercase">{{ strategy.length - 1 }} stops</h6>
            </div>
        </div>
    </div>
    <div class="flex w-11/12 mx-auto lg:w-full text-center lg:max-w-[80vw] flex-wrap justify-center"> 
        <div v-for="(stint, index) in strategy" class="lg:min-w-[100px] mx-5 py-5 relative">
            <div class="">
                <span v-if="index == 0" class="text-xl lg:text-3xl uppercase">Race start</span>
                <span v-else class="text-xl lg:text-3xl uppercase">Lap {{ stint.stintStart }}</span>
                <br>
                <span class="font-bold uppercase text-base lg:text-xl">{{ stint.tyre.name }}</span>
                <img class="h-8 mx-auto mt-1" :src="stint.tyre.image">
            </div>
        </div>
    </div>

</template>

<script>

export default {
  name: "App",
  data() {
    return {
        plan: this.randomPlan(),
    };
  },
  components: {
  },
  methods: {
    getPerc: function(strategy, index) {
        return 10
    },
    randomPlan: function() {
        const alphabet = "abcdefghijklmnopqrstuvwxyz"
        return alphabet[Math.floor(Math.random() * alphabet.length)]
    },
  },
  props: {
    strategy: {
        required: true,
        type: Array
    },
    track: {
        required: true,
        type: Object,
    },
  },
};
</script>